<template>
    <div>
        <a-tabs class="code_tabs" v-model:activeKey="list_activeKey" @change="handleChangeListTab">
            <a-tab-pane key="0" tab="客户"></a-tab-pane>
            <a-tab-pane key="2" tab="车厂"></a-tab-pane>
            <a-tab-pane key="3" tab="车型"></a-tab-pane>
            <a-tab-pane key="1" tab="硬件平台"></a-tab-pane>
        </a-tabs>

        <div class="search_panel">
            <a-select 
                v-if="list_activeKey == '0' || list_activeKey == '3'"
                v-model:value="search.app_id" 
                :options="appIdOptions" 
                allowClear
                placeholder="请选择小程序" 
                style="width: 200px;margin-right: 10px;" 
                @change="handleSelectChangeSearch"
            ></a-select>
            <a-input v-if="list_activeKey == '1'" v-model:value="search.hardware_platform_name" allowClear placeholder="硬件平台名称" style="width: 200px;margin-right: 10px;" @change="handleInputChangeSearch"/>
            <a-input v-if="list_activeKey == '2'" v-model:value="search.manufacturer_name" allowClear placeholder="车厂名称" style="width: 200px;margin-right: 10px;" @change="handleInputChangeSearch"/>
            <a-input v-if="list_activeKey == '0' || list_activeKey == '2'" v-model:value="search.customer_name" allowClear placeholder="客户名称" style="width: 200px;margin-right: 10px;" @change="handleInputChangeSearch"/>

            
            <a-select 
                v-if="list_activeKey == '3'"
                v-model:value="search.customer_code" 
                :options="customerSearchOptions" 
                allowClear
                placeholder="客户名称" 
                style="width: 200px;margin-right: 10px;" 
                @change="handleSelectChangeSearch"
            ></a-select>
            <a-select 
                v-if="list_activeKey == '3'"
                v-model:value="search.manufacturer_name2" 
                :options="factorySearchOptions" 
                allowClear
                placeholder="车厂名称" 
                style="width: 200px;margin-right: 10px;" 
                @change="handleSelectChangeSearch"
            ></a-select>
            <a-select 
                v-if="list_activeKey == '3'"
                v-model:value="search.hardware_platform_code" 
                :options="hardwarePlatformSearchOptions" 
                allowClear
                placeholder="硬件平台名称" 
                style="width: 200px;margin-right: 10px;" 
                @change="handleSelectChangeSearch"
            ></a-select>
            
            <a-input v-if="list_activeKey == '3'" v-model:value="search.model_name" allowClear placeholder="车型名称" style="width: 200px;margin-right: 10px;" @change="handleInputChangeSearch"/>
            
            <a-button type="primary" size="small" class="operate_btn" @click="handleSearch">
                <component :is="$antIcons['SearchOutlined']"></component>
                {{$t('base.search')}}
            </a-button>

            <a-button type="primary" size="small" style="margin-left: 10px;" @click="handle('add')">
                <component :is="$antIcons['PlusOutlined']"></component>
                {{$t('base.add')}}
            </a-button> 
        </div>

        <Table
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button type="link" size="small" class="operate_btn" @click="handle('edit', props.record)">
                        {{$t('base.edit')}}
                    </a-button> 
                    <a-button type="link" size="small" class="operate_btn" @click="handle('delete', props.record)">
                        {{$t('base.delete')}}
                    </a-button> 
                    <a-button v-if="list_activeKey == '0'" type="link" size="small" class="operate_btn" @click="handle('export', props.record)">
                        {{$t('base.export')}}
                    </a-button> 
                </template>
            </template>
        </Table>


        <Modal 
            v-model:visible="visible" 
            :title="modalTitle" 
            width="800px"
            @ok="handleOk" 
            @cancel="handleCancel"
        >
            <a-tabs v-model:activeKey="activeKey" @change="handleChangeTab">
                <a-tab-pane v-if="operateType == 'add' || (operateType == 'edit' && list_activeKey == '0')" key="0" tab="客户"></a-tab-pane>
                <a-tab-pane v-if="operateType == 'add' || (operateType == 'edit' && list_activeKey == '2')" key="2" tab="车厂"></a-tab-pane>
                <a-tab-pane v-if="operateType == 'add' || (operateType == 'edit' && list_activeKey == '3')" key="3" tab="车型"></a-tab-pane>
                <a-tab-pane v-if="operateType == 'add' || (operateType == 'edit' && list_activeKey == '1')" key="1" tab="硬件平台"></a-tab-pane>
            </a-tabs>

            <div class="form_content">
                <div class="form_item" v-if="activeKey == '0' || activeKey == '2' || activeKey == '3'">
                    <div class="form_item_label">小程序名称 <span style="color:red;">*</span></div>
                    <a-select 
                        class="form_item"
                        v-model:value="formData.app_id" 
                        style="width: 100%;"
                        :options="appIdOptions"
                        @change="changeSelect('app')"
                    ></a-select>
                </div>
                <div class="form_item" v-if="activeKey == '2' || activeKey == '3'">
                    <div class="form_item_label">所属客户 <span style="color:red;">*</span></div>
                    <a-select 
                        class="form_item"
                        v-model:value="formData.customer_code" 
                        style="width: 100%;"
                        :options="customerOptions"
                        @change="changeSelect('customer')"
                    ></a-select>
                </div>
                <div class="form_item" v-if="activeKey == '3'">
                    <div class="form_item_label">所属车厂 <span style="color:red;">*</span></div>
                    <a-select 
                        class="form_item"
                        v-model:value="formData.manufacturer_code" 
                        style="width: 100%;"
                        :options="factoryOptions2"
                        @change="changeSelect('factory')"
                    ></a-select>
                </div>
                <div class="form_item" v-if="activeKey == '3'">
                    <div class="form_item_label">所属硬件平台 <span style="color:red;">*</span></div>
                    <a-select 
                        class="form_item"
                        v-model:value="formData.hardware_platform_code" 
                        style="width: 100%;"
                        :options="hardwarePlatformOptions"
                        @change="changeSelect('hardware')"
                    ></a-select>
                </div>
                <div class="form_item">
                    <div class="form_item_label">{{ label_name }} <span style="color:red;">*</span></div>
                    <a-input class="form_item" v-model:value="formData.dict_name"/>
                </div>
                <div class="form_item">
                    <div class="form_item_label">{{ label_code }} <span style="color:red;">*</span></div>
                    <a-input class="form_item" v-model:value="formData.dict_code"/>
                </div>
                <div class="form_item">
                    <div class="form_item_label">{{ label_remark }}</div>
                    <a-input class="form_item" v-model:value="formData.remark" />
                </div>
            </div>
        </Modal>

    </div>
</template>

<script setup>
    import { ref, reactive, onMounted } from 'vue';
    import Table from '@/components/Table.vue';
    import { useI18n } from 'vue-i18n';
    import { useRouter } from 'vue-router';
    import { message, Modal } from 'ant-design-vue';
    import { CodeApi } from '@/api/CodeApi.js';
    import { SmallProgramApi } from '@/api/SmallProgramApi.js';

    const { t } = useI18n()
    const router = useRouter()


    const visible = ref(false)
    const parentOptions = ref([])
    const appIdOptions = ref([])
    const appObj = reactive({})
    const list_activeKey = ref('0')
    const activeKey = ref('0')
    const rowData = ref(null)
    const operateType = ref('add')
    const modalTitle = ref('新增编码')
    const formData = reactive({
        app_id: null,
        dict_name: '',
        dict_code: '',
        remark: '',
        customer_code: null,
        hardware_platform_code: null,
        manufacturer_code: null,
    })
    const search = reactive({
        app_id: null,
        customer_name: '',
        hardware_platform_name: '',
        manufacturer_name: '',
        model_name: '',
        customer_code: null,
        hardware_platform_code: null,
        manufacturer_name2: null,
    })
    const customerOptions = ref([])
    const hardwarePlatformOptions = ref([])
    const factoryOptions = ref([])
    const factoryOptions2 = ref([])
    const customerSearchOptions = ref([])
    const hardwarePlatformSearchOptions = ref([])
    const factorySearchOptions = ref([])

    const label_name = ref('客户名称')
    const label_code = ref('客户编号')
    const label_parent = ref('父级')
    const label_remark = ref('备注')

    const columns2 = ref([
        {
            title: '#',
            dataIndex: 'serial',
            key: 'serial',
            width: 70,
            resizable: true,
            fixed: 'left',
        },
        {
            title: t('code.app_name'),
            dataIndex: 'app_name',
            key: 'app_name',
            resizable: true,
            locel:'user.app_name',
        },
        {
            title: '所属客户',
            dataIndex: 'customer_name',
            key: 'customer_name',
            resizable: true,
        },
        {
            title: '所属车厂',
            dataIndex: 'manufacturer_name',
            key: 'manufacturer_name',
            resizable: true,
        },
        {
            title: '车型名称',
            dataIndex: 'model_name',
            key: 'model_name',
            resizable: true,
        },
        {
            title: '车型编号',
            dataIndex: 'model_code',
            key: 'model_code',
            resizable: true,
        },
        {
            title: '所属硬件平台',
            dataIndex: 'hardware_platform_name',
            key: 'hardware_platform_name',
            resizable: true,
        },
        {
            title: t('code.remark'),
            dataIndex: 'remark',
            key: 'remark',
            resizable: true,
        },
        {
            title: t('code.create_time'),
            dataIndex: 'create_time',
            key: 'create_time',
            resizable: true,
            width: 180,
        },
        {
            title: t('base.operate'),
            key: 'action',
            fixed: 'right',
            width: 200,
            resizable: true,
        },
    ])
    const columns1 = ref([
            {
                title: '#',
                dataIndex: 'serial',
                key: 'serial',
                width: 70,
                resizable: true,
                fixed: 'left',
            },
            {
                title: '车厂名称',
                dataIndex: 'manufacturer_name',
                key: 'manufacturer_name',
                resizable: true,
            },
            {
                title: '车厂编号',
                dataIndex: 'manufacturer_code',
                key: 'manufacturer_code',
                resizable: true,
            },
            {
                title: '客户名称',
                dataIndex: 'customer_name',
                key: 'customer_name',
                resizable: true,
            },
            {
                title: t('code.app_name'),
                dataIndex: 'app_name',
                key: 'app_name',
                resizable: true,
            },
            {
                title: t('code.remark'),
                dataIndex: 'remark',
                key: 'remark',
                resizable: true,
            },
            {
                title: t('code.create_time'),
                dataIndex: 'create_time',
                key: 'create_time',
                resizable: true,
                width: 180,
            },
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: 200,
                resizable: true,
            },
    ])
    
    const columns = ref([
            {
                title: '#',
                dataIndex: 'serial',
                key: 'serial',
                width: 70,
                resizable: true,
                fixed: 'left',
            },
            {
                title: '客户名称',
                dataIndex: 'dict_name',
                key: 'dict_name',
                resizable: true,
                locel:'user.dict_name',
            },
            {
                title: '客户编号',
                dataIndex: 'dict_code',
                key: 'dict_code',
                resizable: true,
                locel:'user.dict_code',
            },
            {
                title: t('code.remark'),
                dataIndex: 'remark',
                key: 'remark',
                resizable: true,
                locel:'user.remark',
            },
            {
                title: t('code.app_name'),
                dataIndex: 'app_name',
                key: 'app_name',
                resizable: true,
                locel:'user.app_name',
            },
            {
                title: t('code.create_time'),
                dataIndex: 'create_time',
                key: 'create_time',
                resizable: true,
                locel:'user.create_time',
                width: 180,
            },
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: 200,
                resizable: true,
            },
    ])
    
    const table = ref({
        data: [],
        columns: columns.value,
        configs: {
            table: {
                pagination: {
                    total: 0,
                },
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1500,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: true,
            pagination: {
                hideOnSinglePage: false,
                position: ['bottomLeft'],
                responsive: true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '50'],
                total: 0,
                showTotal: () => t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const handleChangeListTab = (key) => {
        list_activeKey.value = key
        parentOptions.value = []
        table.value.configs.pagination.current = 1
        switch(list_activeKey.value){
            case '0':
                table.value.columns = [...columns.value]
                table.value.columns[1].title = '客户名称'
                table.value.columns[2].title = '客户编号'
                getList()
                break;
            case '1':
                table.value.columns = [...columns.value]
                table.value.columns[1].title = '硬件平台名称'
                table.value.columns[2].title= '硬件平台编号'
                getList()
                break;
            case '2':
                table.value.columns = [...columns1.value]
                table.value.columns[1].title = '车厂名称'
                table.value.columns[2].title= '车厂编号'
                getFactoryList()
                break;
            case '3':
                table.value.columns = [...columns2.value]
                getSearchOpt('0')
                getSearchOpt('1')
                getFactoryOpt()
                getParentOpt('1')
                getModelList()
                break;
        }
    }

    const handleSearch = () => {
        table.value.configs.pagination.current = 1
        getCodeList()
    }

    const handleSelectChangeSearch = (key) => {
        table.value.configs.pagination.current = 1
        table.value.data = []
        getCodeList()
    }

    const handleInputChangeSearch = (key) => {
        table.value.configs.pagination.current = 1
        getCodeList()
    }


    const handleChangeTab = (key) => {
        activeKey.value = key
        parentOptions.value = []

        if(operateType.value == 'add'){
            for(let key in formData){
                formData[key] = ''
            }
            getCurrentMaxCode(activeKey.value)
        }

        if(key == '0'){
            label_name.value = '客户名称'
            label_code.value = '客户编号'
            label_remark.value = '备注'
        }else if(key == '1'){
            label_name.value = '硬件平台名称'
            label_code.value = '硬件平台编号'
            label_parent.value = '父级(车厂编号/车型编号/硬件平台编号)'
            label_remark.value = '备注'
        }else if(key == '2'){
            label_name.value = '车厂名称'
            label_code.value = '车厂编号'
            label_parent.value = '父级(车厂编号/车型编号/硬件平台编号)'
            label_remark.value = '备注'
        }else if(key == '3'){
            label_name.value = '车型名称'
            label_code.value = '车型编号'
            label_parent.value = '父级(车厂编号/车型编号/硬件平台编号)'
            label_remark.value = '备注'
            getParentOpt('1')
        }
    }


    const handle = (type, row) => {
        switch(type){
            case 'add':
                operateType.value = 'add'
                visible.value = true
                modalTitle.value = '新增编码'
                activeKey.value = list_activeKey.value
                handleChangeTab(activeKey.value)
                break;
            case 'delete':
                Modal.confirm({
                    title: '提示',
                    content: list_activeKey.value == '0' ? '删除该客户，其对应车型的所有相关联的数据都会相应删除，是否确定删除？' : list_activeKey.value == '1' ? '删除该硬件平台，其对应车型的所有相关联的数据都会相应删除，是否确定删除？' : list_activeKey.value == '2' ? '删除该车厂，其对应车型的所有相关联的数据都会相应删除，是否确定删除？' : '是否确认删除？ 删除后将无法恢复',
                    okText: t('base.yes'),
                    cancelText: t('base.no'),
                    onOk() {
                        handleDelete(row)
                    }
                })
                break;
            case 'edit':
                if(list_activeKey.value == '3'){
                    editCode(row)
                }else{
                    Modal.confirm({
                        title: '提示',
                        content: list_activeKey.value == '0' ? '编辑该客户，其对应车型的所有相关联的数据都会相应改变，是否继续编辑？' : list_activeKey.value == '1' ? '编辑该硬件平台，其对应车型的所有相关联的数据都会相应改变，是否继续编辑？' : '编辑该车厂，其对应车型的所有相关联的数据都会相应改变，是否继续编辑？',
                        okText: t('base.yes'),
                        cancelText: t('base.no'),
                        onOk() {
                            editCode(row)
                        }
                    })
                }
                break;
            case 'export':
                exportCustomer(row.id, row.app_id)
                break;
        }
    }

    const editCode = (row) => {
        operateType.value = 'edit'
        visible.value = true
        modalTitle.value = '编辑编码'
        activeKey.value = list_activeKey.value
        rowData.value = row
        handleChangeTab(activeKey.value)
                            
        formData.app_id = row.app_id

        getCustomerOpt('0')
        getParentOpt('1')
        getFactoryOpt2()

        if(list_activeKey.value == '3'){
            formData.dict_name = row.model_name
            formData.dict_code = row.model_code
            formData.customer_code = row.customer_code  
            formData.hardware_platform_code = row.hardware_platform_code  
            formData.manufacturer_code = row.manufacturer_code
        }else if(list_activeKey.value == '2'){
            formData.dict_name = row.manufacturer_name
            formData.dict_code = row.manufacturer_code
            formData.customer_code = row.customer_code  
            formData.app_id = row.app_id  
        }else{
            formData.dict_name = row.dict_name
            formData.dict_code = row.dict_code
        }

        formData.remark = row.remark == '-' ? '' : row.remark
    }

    const handleChangePagination = (config) => {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getCodeList()
    }

    const changeSelect = (key)=>{
        if(key == 'app'){
            formData.customer_code = ''
            formData.hardware_platform_code = ''
            formData.manufacturer_code = ''
            factoryOptions2.value = []
            getCustomerOpt('0')
        }else if(key == 'customer'){
            formData.hardware_platform_code = ''
            formData.manufacturer_code = ''
            getFactoryOpt2()
        }
        
        // else if(key == 'hardware'){
        //     formData.manufacturer_code = ''
        //     getParentOpt('2')
        // }
    }

    const validate = () => {
        if(activeKey.value == '0'){
            if(!formData.app_id){
                message.error('请选择小程序名称！')
                return false
            }else if(!formData.dict_name){
                message.error('请填写客户名称！')
                return false
            }else if(!formData.dict_code){
                message.error('请填写客户编号！')
                return false
            }
        }

        if(activeKey.value == '1'){
            if(!formData.dict_name){
                message.error('请填写硬件平台名称！')
                return false
            }else if(!formData.dict_code){
                message.error('请填写硬件平台编号！')
                return false
            }
        }

        if(activeKey.value == '2'){
            if(!formData.dict_name){
                message.error('请填写车厂名称！')
                return false
            }else if(!formData.dict_code){
                message.error('请填写车厂编号！')
                return false
            }
        }

        if(activeKey.value == '3'){
            if(!formData.app_id){
                message.error('请选择小程序名称！')
                return false
            }else if(formData.customer_code == ''){
                message.error('请选择所属客户！')
                return false
            }else if(formData.hardware_platform_code == ''){
                message.error('请选择所属硬件平台！')
                return false
            }else if(formData.manufacturer_code == ''){
                message.error('请选择所属车厂！')
                return false
            }else if(!formData.dict_name){
                message.error('请填写车型名称！')
                return false
            }else if(!formData.dict_code){
                message.error('请填写车型编号！')
                return false
            }
        }

        return true
    }

    const handleOk = async() => {
        if(!validate()) return

        let form_data = {}
        for(let key in formData){
            if(operateType.value == 'edit' && list_activeKey.value == '3'){
                if(key == 'dict_code'){
                    form_data['model_code'] = formData[key]
                }else if(key == 'dict_name'){
                    form_data['model_name'] = formData[key]
                }else{
                    form_data[key] = formData[key]
                }
            }if(operateType.value == 'edit' && list_activeKey.value == '2'){
                if(key == 'dict_code'){
                    form_data['manufacturer_code'] = formData[key]
                }else if(key == 'dict_name'){
                    form_data['manufacturer_name'] = formData[key]
                }else if(key != 'manufacturer_code'){
                    form_data[key] = formData[key]
                }
            }else{
                form_data[key] = formData[key]
            }
        }

        let param = {
            ...form_data,
            dict_type: activeKey.value,
        }
        let res = operateType.value == 'add'
                ? await CodeApi.getInstance().addCode(param) 
                : list_activeKey.value == '3' 
                ? await CodeApi.getInstance().editModelCode(param, rowData.value.id)
                : list_activeKey.value == '2' 
                ? await CodeApi.getInstance().editFactoryCode(param, rowData.value.id)
                : await CodeApi.getInstance().editCode(param, rowData.value.id)
        if(res.code == 0){
            message.success(operateType.value == 'add' ? '新增成功' : '编辑成功')
            visible.value = false
            list_activeKey.value = activeKey.value
            getCodeList()
        }else{
            message.error(res.msg)
        }
    }

    const getCodeList = () => {
        if(list_activeKey.value == '2'){
            getFactoryList()
        }else if(list_activeKey.value == '3'){
            getModelList()
        }else{
            getList()
        }
    }

    // 获取客户、平台编码列表
    const getList = async() => {
        let param = {
            dict_type: list_activeKey.value,
            app_id: search.app_id,
            dict_name: list_activeKey.value == 0? search.customer_name : search.hardware_platform_name,
            // hardware_platform_code: search.hardware_platform_name,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await CodeApi.getInstance().getCodeList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.forEach((i, index) => {
                i.serial = index + 1
                i.parent_code = i.parent_code == null? '-' : i.parent_code
                i.app_name = !i.app_id? '-' : appObj[i.app_id]
                i.remark = !i.remark? '-' : i.remark
                i.create_time = i.create_time == undefined? '-' : i.create_time
            })
            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            message.error(res.msg)
        }
    }

    // 获取车厂编码列表
    const getFactoryList = async() => {
        let param = {
            customer_name: search.customer_name,
            manufacturer_name: search.manufacturer_name,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await CodeApi.getInstance().getFactoryCodeList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.forEach((i, index) => {
                i.serial = index + 1
                i.parent_code = i.parent_code == null? '-' : i.parent_code
                i.app_name = !i.app_id? '-' : appObj[i.app_id]
                i.remark = !i.remark? '-' : i.remark
                i.create_time = i.create_time == undefined? '-' : i.create_time
            })
            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            message.error(res.msg)
        }
    }

    // 获取车型编码列表
    const getModelList = async() => {
        let param = {
            app_id: search.app_id,
            customer_code: search.customer_code,
            hardware_platform_code: search.hardware_platform_code,
            manufacturer_name: search.manufacturer_name2,
            model_name: search.model_name.trim(),
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await CodeApi.getInstance().getModelCodeList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.forEach((i, index) => {
                i.serial = index + 1
                i.parent_code = i.parent_code == null? '-' : i.parent_code
                i.app_name = !i.app_id? '-' : appObj[i.app_id]
                i.remark = !i.remark? '-' : i.remark
                i.create_time = i.create_time == undefined? '-' : i.create_time
            })
            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            message.error(res.msg)
        }
    }

    const handleDelete = async(row) => {
        let res = list_activeKey.value == '3' 
            ? await CodeApi.getInstance().deleteModelCode(row.id) 
            : list_activeKey.value == '2'
            ? await CodeApi.getInstance().deleteFactoryCode(row.id)
            : await CodeApi.getInstance().deleteCode(row.id)
        if(res.code == 0){
            getCodeList()
        }else if(res.code == 1246 || res.code == 1242){
            Modal.warning({
                title: '提示',
                content: res.msg,
            })
            getCodeList()
        }else{
            message.error(res.msg)
        }
    }

    const exportCustomer = async (id, app_id)=>{
        let res = await CodeApi.getInstance().exportCustomer(id, app_id)
        if(res){
            let blob = new Blob([res], { type: 'application/octet-stream' })
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = '客户配置数据.xlsx'
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            message.success('导出成功')
        }else{
            message.error(res.msg)
        }
    }


    // 获取用户小程序名称
    const getAppNameList = async ()=> {
        let param = {
            status:0,
        }
        let res = await SmallProgramApi.getInstance().getSmallProgramQuery(param)
        if (res.code == 0) {
            res.data.length > 0 && res.data.forEach(item=>{
                appIdOptions.value.push({
                    label: item.app_name,
                    value: item.app_id,
                })
                appObj[item.app_id] = item.app_name
            })
        } else {
            message.error(res.msg);
        }
    } 

    // 获取客户下拉列表
    const getCustomerOpt = async() => {
        let param = {
            dict_type: '0',
            app_id: formData.app_id,
        }
        let res = await CodeApi.getInstance().getParentOpt(param)
        if(res.code == 0){
            customerOptions.value = []
            customerOptions.value = res.data.length > 0 && res.data.map(item=>({
                label: item.dict_name,
                value: item.dict_code,
            }))
        }else {
            message.error(res.msg)
        }
    }

    // 获取车厂下拉列表
    const getFactoryOpt = async() => {
        let res = await CodeApi.getInstance().getFactoryOpt({})
        if(res.code == 0){
            factorySearchOptions.value = []
            factorySearchOptions.value = res.data.length > 0 && res.data.map(item=>({
                label: item.manufacturer_name,
                value: item.manufacturer_name,
            }))
        }else{
            message.error(res.msg)
        }
    }

    
    const getFactoryOpt2 = async() => {
        let param = {
            app_id: formData.app_id,
            customer_code: formData.customer_code,
        }
        let res = await CodeApi.getInstance().getFactoryOpt2(param)
        if(res.code == 0){
            factoryOptions2.value = []
            factoryOptions2.value = res.data.length > 0 && res.data.map(item=>({
                label: item.manufacturer_name,
                value: item.manufacturer_code,
            }))
        }else{
            message.error(res.msg)
        }
    }

    // 获取父级下拉列表
    const getParentOpt = async(dict_type) => {
        let param = {
            dict_type: Number(dict_type),
        }
        let res = await CodeApi.getInstance().getParentOpt(param)
        if(res.code == 0){
            if(dict_type == '1'){
                hardwarePlatformOptions.value = []
                hardwarePlatformOptions.value = res.data.length > 0 && res.data.map(item=>({
                    label: item.dict_name,
                    value: item.dict_code,
                }))
            }else if(dict_type == '2'){
                factoryOptions.value = []
                factoryOptions.value = res.data.length > 0 && res.data.map(item=>({
                    label: item.dict_name,
                    value: item.dict_code,
                }))
            } 
        }else{
            message.error(res.msg)
        }
    }

    // 获取搜索下拉列表
    const getSearchOpt = async(dict_type) => {
        let param = {
            dict_type: dict_type,
        }
        let res = await CodeApi.getInstance().getParentOpt(param)
        if(res.code == 0){
            if(dict_type == '0'){
                customerSearchOptions.value = res.data.length > 0 && res.data.map(item=>({
                    label: item.dict_name,
                    value: item.dict_code,
                }))
            }else if(dict_type == '1'){
                hardwarePlatformSearchOptions.value = res.data.length > 0 && res.data.map(item=>({
                    label: item.dict_name,
                    value: item.dict_code,
                }))
            }
            // else if(dict_type == '2'){
            //     factorySearchOptions.value = res.data.length > 0 && res.data.map(item=>({
            //         label: item.dict_name,
            //         value: item.dict_code,
            //     }))
            // } 
        }else{
            message.error(res.msg)
        }
    }

    // 获取当前最大编码
    const getCurrentMaxCode = async(dict_type) => {
        let param = {
            dict_type: dict_type,
        }
        let res = await CodeApi.getInstance().getCurrentMaxCode(param)
        if(res.code == 0){
            formData.dict_code = res.data.max_dict_code
        }else{
            message.error(res.msg)
        }
    }


    onMounted(()=>{
        getAppNameList()
        getList()
    })
</script>

<style lang="scss" scoped>
    .code_tabs{
        margin-left:20px;
    }
    .form_content{
        margin-top: 20px;
        background: #fff;
        border-radius: 5px;

        .form_item{
            margin-bottom: 10px;

            .form_item_label{
                font-size: 14px;
                font-weight: 600;
                margin-bottom: 5px;
            }
        }
    }


    .search_panel{
        margin-bottom: 10px;
    }
    
    
</style>